import { render, staticRenderFns } from "./IndicatorsRed.vue?vue&type=template&id=cd5a20ba&scoped=true&"
import script from "./IndicatorsRed.vue?vue&type=script&lang=js&"
export * from "./IndicatorsRed.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorsRed.vue?vue&type=style&index=0&id=cd5a20ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5a20ba",
  null
  
)

export default component.exports